import packageJson from '../../package.json';

export const common = {
	version: packageJson.version
};
